import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, inject, ChangeDetectionStrategy, signal, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterModule } from '@angular/router';
import { ProfileComponent } from '../../components/profile/profile.component';
import { NotificationWebsocketService } from '../../shared/services/notification-websocket/notification-websocket.service';
import { NotificationService } from '../../shared/services/notification/notification.service';
import { ApiUserService } from '../../shared/services/api-user/api-user.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    MatListModule,
    MatIconModule,
    MatBadgeModule,
    MatSlideToggleModule,
    RouterModule,
    ProfileComponent,
  ],
})
export class SidebarComponent implements OnInit {
  private notificationWebsocketService = inject(NotificationWebsocketService);
  notificationService = inject(NotificationService);
  private userService = inject(ApiUserService);
  private destroyRef = inject(DestroyRef);

  invitesCount = signal(0);

  ngOnInit(): void {
    this.fetchInvitesCount();

    // Listen for invite-related WebSocket messages to update badge count
    // This provides real-time updates when invites are sent/received/updated
    this.notificationWebsocketService
      .receiveMessage()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((msg) => {
        // Check if message contains invite-related content
        if (this.isInviteRelated(msg)) {
          // Refresh the invite count badge
          this.fetchInvitesCount();
        }
      });
  }

  private fetchInvitesCount(): void {
    this.userService.getCurrentUserInvites().subscribe((invites) => {
      this.invitesCount.set(invites.filter(
        (invite) => invite.response === 'Open',
      ).length);
    });
  }

  private isInviteRelated(msg: any): boolean {
    // You may want to refine this check based on your backend's message types
    // For now, check if message or details mention 'invite'
    return (
      msg &&
      (msg.message?.toLowerCase().includes('invite') ||
        (msg.details &&
          JSON.stringify(msg.details).toLowerCase().includes('invite')))
    );
  }
}
